<template>
<div class='loading-content'>
    <div class=content>
        <crumb></crumb>
        <div class="loading-center">
            <div class="codeBox">
                    Extracted code：<span>{{this.$route.query.code}}</span>
            </div>
            <p class="load-message">Data generation takes a certain amount of time, please remember the code, and try to extract result later with the code.</p>
            <div class="seach">
                    <input type="text" placeholder="Extracted code" v-model="code">
                    <div class="btn" @click="check">Check</div>
            </div>
            <p class="wait">please wait a moment..</p>
        </div>
    </div>
</div>
</template>

<script>
import crumb from '../components/crumb';
import state from '../api/store'

export default {
components: {
    crumb
},
data() {
return {
    code:'',
};
},
computed: {},
watch: {},
created() {
    let routeName = this.$route.meta.title;
    state.save(routeName,1);
},
mounted() {

},
methods: {
    check(){
        this.$showLoading();
        this.api.seachType({code:this.code},res=>{
                this.$hideLoading();
                if(res.data == ''){
                    alert('code不存在');
                }
                else{
                    this.setCrumb(res.data);
                    if(res.data == '10013'){
                        this.api.seachPicResult({code:this.code},res=>{
                            this.$hideLoading();
                            if(res.data == 'error'){
                                //未生成图片
                                alert('该图片数据尚未生成,请稍后再尝试提取');
                            }else{
                                this.$router.push({path:'/result',query:{path:res.data,code:this.code,isExp:false,isCheck:true,title:state.crumb[1]}});
                            }
                        });
                    }else{
                        this.$router.push({path:'/result',query:{path:res.data,code:this.code,isCheck:true,title:state.crumb[1]}});
                    }
                }
        });
    },
    setCrumb(e){
        let data = state.tabData;
        let arr = e.split('');
        console.log(arr);
        let index = 1;
        for(let i in data){
            if(index == arr[0]){
                state.crumb[0] = i;
                let inside = 1;
                for(let s in data[i]){
                    if(inside == arr[arr.length-1]){
                        state.crumb[1] = s;
                    }
                    inside++;
                }
            }

            index++;
        }
        console.log(state.crumb);
    },
},
}
</script>
<style lang='scss' scoped>

</style>
